import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-programa',
  templateUrl: './home-programa.component.html',
  styleUrls: ['./home-programa.component.scss']
})
export class HomeProgramaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
